import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Divider, Typography } from '@mui/material';
import ArrowRight from "@mui/icons-material/ArrowRight";

import styles from "./styles";

const DiscountTypeSelectionDialog = ({ isOpen, onDiscountTypeSelected, onCancelPressed }) => {

  const classes = styles();

  const _onDiscountTypeSelected = (value) => {
    onDiscountTypeSelected(value);
  };

  return (
    <Dialog open={isOpen} onClose={onCancelPressed}>
      <Typography color='primary' variant='h6' style={{ padding: 20 }}>Select discount type</Typography>
      <DialogContent style={{ width: 500 }}>
        <div className={classes.item} onClick={() => _onDiscountTypeSelected("AMOUNT_OFF_PRODUCTS")}>
          <div>
            <Typography variant='body1'>{"Amount off products"}</Typography>
            <Typography variant='caption'>{"Product discount"}</Typography>
          </div>
          <ArrowRight />
        </div>
        <div className={classes.item} onClick={() => _onDiscountTypeSelected("AMOUNT_OFF_ORDER")}>
          <div>
            <Typography variant='body1'>{"Amount off order"}</Typography>
            <Typography variant='caption'>{"Order discount"}</Typography>
          </div>
          <ArrowRight />
        </div>
        <div className={classes.item} onClick={() => _onDiscountTypeSelected("BUY_X_GET_Y")}>
          <div>
            <Typography variant='body1'>{"Buy X get Y"}</Typography>
            <Typography variant='caption'>{"Product discount"}</Typography>
          </div>
          <ArrowRight />
        </div>
      </DialogContent>
      <DialogActions className={classes.modalActions}>
        <Button onClick={onCancelPressed} color="primary">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DiscountTypeSelectionDialog;